import store from '@/store';
import BemobApi from '@/services/rest/bemob';
const bemobApi: BemobApi = new BemobApi();

export default async (to: any, from: any, next: Function) => {
  const { authToken } = store.state;
  if(authToken){
    const { isProfileLoaded } = store.state;
    if(!isProfileLoaded){
      await bemobApi.loadProfileData();
    }

    const { user } = store.state;
    const isEmailVerificationRequired = user?.id && !user?.emailVerified;

    return isEmailVerificationRequired
      ? next()
      : from && from.name
      ? next(false)
      : next('/');
  }

  return next({ path: '/login', query: { redirect: to.fullPath } });
}
